export default __webpack_public_path__ + "static/media/nasscom.be75f9ce.jpg";